<template>
    <div class="sidebar-filter">
        <!--        <div class="label">{{ $t('location.filter.title') }}</div>-->
        <!--        <h3 class="sidebar-filter__title h6">{{ $t('location.filter.location') }}</h3>-->
        <!--        <div class="sidebar-filter__body place">-->
        <!--            <div class="place__content">-->
        <!--                <label class="title hide-xs">{{ $t('location.filter.yourLocation') }}:</label>-->
        <!--                <i class="ico ico&#45;&#45;point me-2"></i>-->
        <!--                <input-->
        <!--                    ref="placeAutocomplete"-->
        <!--                    type="text"-->
        <!--                    placeholder=""-->
        <!--                    :value="address"-->
        <!--                    class="text-input"-->
        <!--                    @focusout="inputFocusOut"-->
        <!--                    @focusin="locationActive = true"-->
        <!--                />-->
        <!--                <i class="ico ico&#45;&#45;my-place hide-xs" @click="setUserLocation"></i>-->
        <!--            </div>-->
        <!--            <button class="btn btn-primary btn-lg" @click="buttonClicked">-->
        <!--                {{ $t('location.filter.change.text') }}-->
        <!--                <span class="hide-xs">{{ $t('location.filter.change.small') }}</span>-->
        <!--            </button>-->
        <!--        </div>-->
    </div>
</template>

<style lang="scss" scoped>
//@import '~bootstrap/scss/functions';
//@import '~bootstrap/scss/variables';
//@import '~bootstrap/scss/mixins';

.smap-suggest {
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    top: 100% !important;
    width: auto !important;
    z-index: 99999 !important;
}

.template-xs .smap-suggest {
    width: 350px !important;
}

.radius-box {
    padding-top: 0;
    padding-bottom: 1em;
    justify-content: center;
    text-align: center;
    font-size: 14px;
}

.location {
    font-size: 18px;
    border-radius: 5px;

    &--homepage {
        background-color: $color-white;
        padding: 20px 0;
        margin: 60px auto 0 auto;
        position: relative;
        border-radius: 20px;
        box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%);
        max-width: $max-width-container-inside;

        .radius-box {
            padding-top: 1em;
            padding-bottom: 0;
            font-size: 18px;

            label {
                font-size: 18px;
            }
        }

        .label {
            text-align: center;
            font-size: 18px;
            margin-bottom: 10px;
            font-weight: 500;

            /* @include media-breakpoint-down(md) {
                display: none;
            }*/
        }

        .changeLocation {
            display: none;
        }

        .sidebar-filter {
            width: 80%;
            margin: 0 auto;
        }

        .place {
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            position: relative;
            z-index: 2;

            .btn {
                height: 50px;
                font-size: 18px;
                line-height: 22px;
                padding: 13px 25px;
                border-radius: 25px;
            }

            &__content {
                display: flex;
                align-items: center;
                border: 1px solid $color-grey-dark;
                background-color: $color-grey;
                width: 60%;
                margin-right: 1.5rem;
                position: relative;
                padding: 0 1.5em;
                border-radius: 100px;

                label {
                    font-size: 18px;
                    margin: 0 10px 0 0;
                    color: $color-grey-extra-dark;
                    white-space: nowrap;
                }
            }

            /*@include media-breakpoint-down(md) {
                flex-direction: column;

                label {
                    display: none;
                }

                .place__content {
                    width: 100%;
                    margin: 0;
                }

                .btn {
                    width: 100%;
                    margin-top: 10px;
                }
            }*/
        }

        .h6 {
            display: none;
        }

        /*@include media-breakpoint-down(md) {
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding: 20px;
        }*/

        &__label {
            font-size: 1.2rem;
            left: 21%;
            position: absolute;
            margin-bottom: 0;
            padding: 8px 0 0 15px;

            /*@include media-breakpoint-down(md) {
                position: relative;
                left: 0;
            }*/
        }

        input.text-input {
            width: 100%;
            height: 48px;
            background-color: transparent;
            border: none;
            outline: none;
            font-weight: 500;
        }

        button {
            /* @include media-breakpoint-down(md) {
                width: 100%;
            }*/
        }
    }
}

.ico--my-place {
    flex: 0 0 auto;
    filter: grayscale(1);
    opacity: 0.38;
    transition: 150ms ease-in-out;
    cursor: pointer;
    margin-right: -5px;

    &:hover {
        filter: none;
        opacity: 1;
        transition: 150ms ease-in-out;
    }
}

.md-template {
    background-color: $color-white;
    padding: 20px 0;
    position: relative;
    max-width: 780px;
    margin: 0 auto;

    .changeLocation {
        display: none;
    }

    .label {
        display: none;
    }

    .sidebar-filter {
        width: 80%;
        margin: 0 auto;
    }

    .place {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        position: relative;
        z-index: 2;

        .btn {
            height: 50px;
            font-size: 18px;
            line-height: 22px;
            padding: 13px 25px;
            white-space: nowrap;
            border-radius: 25px;
        }

        &__content {
            display: flex;
            align-items: center;
            border: 1px solid $color-grey-dark;
            background-color: $color-grey;
            width: 100%;
            margin-right: 1.5rem;
            position: relative;
            border-radius: 20px;
            padding: 0 1em;

            label {
                font-size: 18px;
                margin: 0 10px 0 0;
                color: $color-grey-extra-dark;
                white-space: nowrap;
            }
        }

        /* @include media-breakpoint-down(md) {
            flex-direction: column;

            label {
                display: none;
            }

            .place__content {
                width: 100%;
                margin: 0;
            }

            .btn {
                width: 100%;
                margin-top: 10px;
            }
        }*/
    }

    .h6 {
        display: none;
    }

    &__label {
        font-size: 1.2rem;
        left: 21%;
        position: absolute;
        margin-bottom: 0;
        padding: 8px 0 0 15px;

        /*@include media-breakpoint-down(md) {
            position: relative;
            left: 0;
        }*/
    }

    input.text-input {
        width: 100%;
        height: 48px;
        background-color: transparent;
        border: none;
        outline: none;
        font-weight: 500;
    }

    button {
        /* @include media-breakpoint-down(md) {
            width: 100%;
        } */
    }
}

.template-xs {
    font-size: 14px;
    box-shadow: none !important;
    border-radius: 0 !important;

    .label {
        display: none;
    }

    .hide-xs {
        display: none;
    }

    .place-input {
        width: auto;
    }

    .place {
        &__content {
            position: relative;
        }
    }

    .btn-primary {
        background: none;
        font-size: 14px;
        padding: 0;
        height: auto;
        color: $color-cta;
        border: none;
        text-decoration: underline;
        padding-left: 0.5em;

        &:hover {
            background: none;
            color: #9a0054;
            text-decoration: none;
        }

        &:not(:disabled):not(.disabled):focus,
        &:not(:disabled):not(.disabled):active {
            background: none;
            color: #9a0054;
        }
    }
}
</style>
